export default __webpack_public_path__ + "static/media/RoadsideImage.8e91022d.svg";